<style>
.table-dashboard thead tr td {
    background: #1f2248;
    color: #fff;
}
</style>
<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title=" Laporan Lejar">
            <w-form ref="dform" @validate="search">
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_dari"
                            required
                            label="Dari"
                            type="date"
                        />
                        <z-lookup
                            label="Akaun"
                            :url="service_utiliti + 'lookup/akaun_jurnal'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.akaun_id"
                        />
                    </div>
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_hingga"
                            required
                            label="Hingga"
                            type="date"
                        />
                     <!-- <z-lookup :url="service_kutipan +'lookup/jabatan_baharu'" -->
                        <z-lookup :url="service_utiliti +'lookup/jabatan_jurnal'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.jabatan_id"
                            label="jabatan"
                        />
                    </div>
                   
                </w-flex>
            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button
                        class="ml1"
                        v-on:click="reset()"
                        bg-color="warning"
                    >
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1" @click="$refs.dform.validate()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>
            <center v-if="loading == true"><w-progress class="ma1" circle></w-progress></center>
            <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode">
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                                <!-- <td>BIL</td> -->
                                <td>KETERANGAN</td>
                                <td>AMAUN DEBIT (RM)</td>
                                <td>AMAUN KREDIT (RM)</td>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="table.lejar">
                                <template v-for="(dt, index) in table.lejar">
                                    <tr>
                                        <!-- <td>{{ dt.no }}</td> -->
                                        <td><b>{{ dt.keterangan }}</b></td>
                                        <td style="text-align: right"><b>{{ dt.amaun_debit }}</b></td>
                                        <td style="text-align: right"><b>{{ dt.amaun_kredit }}</b></td>
                                    </tr>
                                    <tr v-for="(lj, idx) in dt.lejar">
                                        
                                            <td>
                                                <inertia-link :href="$route('utiliti.laporan.lejarlv2',lj.akaun_id)+ 
                                                '?tarikh_dari=' + cari.tarikh_dari + '&tarikh_hingga=' +cari.tarikh_hingga+
                                                '&amaun_debit=' + lj.amaun_debit + '&amaun_kredit=' +lj.amaun_kredit+
                                                '&akaun='+lj.akaun_kod+' | '+lj.akaun_keterangan">
                                                    &nbsp;&nbsp;{{ lj.akaun_kod }} <span v-if="lj.akaun_kod != ''">|</span> {{ lj.akaun_keterangan }}
                                                </inertia-link>
                                            </td>
                                            <td style="text-align: right">{{ lj.amaun_debit }}</td>
                                            <td style="text-align: right">{{ lj.amaun_kredit }}</td>
                                        
                                    </tr>
                                </template>
                                <tr>
                                    <td><b>JUMLAH</b></td>
                                    <td style="text-align: right"><b>{{table.total_debit}}</b></td>
                                    <td style="text-align: right"><b>{{table.total_kredit}}</b></td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="3" style="text-align: center">Tiada Rekod</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                    <!-- <w-card class="text-right">
                        <w-flex
                            v-if="table.meta.current_page"
                            class="justify-start align-center"
                        >
                            <pagination
                                class="xs11"
                                :max="table.meta.last_page"
                                :path="table.meta.path"
                                :current="table.meta.current_page"
                                :last_page="table.meta.last_page"
                                :links="table.meta.links"
                                @pageChanged="table.loadpg"
                            />
                        </w-flex>
                    </w-card> -->
                </div>
            </w-flex>

            <w-flex class="mt1 mb3" justify-center>
                <div class="mt2 text-center">
                    <w-button bg-color="success" class="mr3" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                </div>
            </w-flex>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
        auth: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_laporan + "kutipan/laporan/dummy",
            reload: true,
            loading: false,
            status: [
                {
                    value: 1,
                    label: "Aktif",
                },
                {
                    value: 2,
                    label: "Tidak Aktif",
                },
            ],
            crumbs: [
                { label: "iHasil", route: "/" },
                { label: "Utiliti", route: "/utiliti/laporan/"},
                { label: "Laporan", route: "/utiliti/laporan/lejar"},
                {
                    label: "Laporan Lejar",
                    route: "/utiliti/laporan/lejar",
                },
            ],
            cari: { tarikh_dari: "", tarikh_hingga: "", akaun_id: "", jabatan_id: "" },
        };
    },
    methods: {
        search() {
            this.getDataQuery();
        },

        reset() {
            this.cari = { tarikh_dari: "", tarikh_hingga: "", akaun_id: "", jabatan_id: "" };
            this.search();
        },

        cetak() {
            window.open(this.service_utiliti+'lejar?user_id='+this.auth.user.id+'&cetak=true'+
            "&tarikh_dari=" + this.cari.tarikh_dari +
            "&tarikh_hingga=" + this.cari.tarikh_hingga+
            "&akaun_id=" + this.cari.akaun_id+
            "&jabatan_id=" + this.cari.jabatan_id,'_blank');
            },
        async getDataQuery() {
            this.loading = true;
            const resp = await axios.get(
                this.service_utiliti + "lejar?user_id=" + this.auth.user.id +
                    "&tarikh_dari=" + this.cari.tarikh_dari +
                    "&tarikh_hingga=" + this.cari.tarikh_hingga +
                    "&akaun_id=" + this.cari.akaun_id+
                    "&jabatan_id=" + this.cari.jabatan_id
            );
            this.table = resp.data;
            this.loading = false;
        },
    },
    watch: {},
    mounted() {
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.tarikh_dari == "undefined") {
            this.cari.tarikh_dari = "";
        }
        if (this.cari.tarikh_hingga == "undefined") {
            this.cari.tarikh_hingga = "";
        }
        if (this.cari.akaun_id == "undefined") {
            this.cari.akaun_id = "";
        }
        if(this.cari.goback){
            this.getDataQuery();
        }
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
